<template>
  <div class="center">
    <v-layout row justify-center>
      <v-card flat>
        <iframe src="https://break2000.com/sources/index.php?client=5b7c246d91aa9" frameborder="0" style="display: block;overflow:hidden;height: 100vh;width: 100vw;"></iframe>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
    export default {
        name: "home-value"
    }
</script>

<style scoped>

</style>
